import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css'; // This file contains the necessary dropdown styles

// Accept onLinkClick and give it a default empty function to prevent errors
const CompanyDropdown = ({ onLinkClick = () => {} }) => {
  return (
    <div className="dropdown-container">
      <div className="--standard-matrix flex-col">
        {/* Add onClick={onLinkClick} to every link */}
        <Link to="/about" className="nav-standard-link" role="menuitem" onClick={onLinkClick}>
          About
        </Link>
        <Link to="/news" className="nav-standard-link" role="menuitem" onClick={onLinkClick}>
          News
        </Link>
        <Link to="/careers" className="nav-standard-link" role="menuitem" onClick={onLinkClick}>
          Careers
        </Link>
        <Link to="/security" className="nav-standard-link" role="menuitem" onClick={onLinkClick}>
          Security
        </Link>
        <Link to="/contact-us" className="nav-standard-link" role="menuitem" onClick={onLinkClick}>
          Contact us
        </Link>
      </div>
    </div>
  );
};

export default CompanyDropdown;